import { useEffect, useRef, useState } from 'react';
import './manage-contributions.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import ManageContributionCard from './manage-contribution-card.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { useSelector } from 'react-redux';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const ManageContributions = ({
    gameData,
    playerList,
    gameStats,
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [contributionsToDisplay, setContributionsToDisplay] = useState([]);
    const contributionsRef = useRef({});
    const contributionsListenerRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const gameId = gameData?.gameId;
    const isPreview = location.pathname.includes('/preview/manager/');

    useEffect(() => {
        if (!gameData?.gameName) return;
        changeDocumentTitle(`Contributions | Manage ${gameData?.gameName}`);
    }, [gameData?.gameName])

    useEffect(() => {
        if (!gameId) return;
        if (isPreview) {
            const contributionObj = {};
            if (!completeGameElementData) return;
            Object.values(completeGameElementData)
                .filter(e => 
                    e.type === 'item' && 
                    e.opt_itemType === 'contribution' && 
                    e.status === 'active')
                .forEach(e => {
                    contributionObj[e.id] = e;
                });
            setContributionsToDisplay(Object.values(contributionObj));
            return;
            return;
        }
        getContributionsToDisplay();

        function getContributionsToDisplay() {
            getCollectionFromDb({
                "collection": `games/${gameId}/gameElements`,
                "query1": {
                    "key": "opt_itemType",
                    "condition": "==",
                    "value": "contribution"
                },
                "callback": callback,
                "handleListener": handleListener
            })
            function callback(data) {
                console.log(data);
                contributionsRef.current = {
                    ...contributionsRef.current,
                    ...{ [data.id]: data }
                }
                setContributionsToDisplay(Object.values(contributionsRef.current));
            }
            function handleListener(data) {
                contributionsListenerRef.current = data;
            }
        }

        return () => {
            if (contributionsListenerRef.current) {
                contributionsListenerRef.current();
            }
        }
    }, [gameId, isPreview, completeGameElementData]);


    return (
        <div className={`manage-contributions ${screenSize}`}>
            <div className='g-card contributions-card'>
                <BackButton cancel={() => navigate(`${isPreview
                    ? '/preview/manager'
                    : '/manage'
                    }/${gameData?.path}`)} />
                <div className="g-space-1"></div>
                <div className='card-title'>
                    <div className='title-with-icon'>
                        <FontAwesomeIcon icon={faPiggyBank} />Manage Contributions
                    </div>
                </div>
                <hr />
                <div className='contribution-list'>
                    {
                        (contributionsToDisplay.length > 0)
                            ?
                            contributionsToDisplay.map(c => (
                                <div
                                    key={c.id}
                                    className='contribution-card' >
                                    <ManageContributionCard
                                        gameData={gameData}
                                        item={c}
                                        gameStats={gameStats}
                                        // gameActivity={gameActivity}
                                        playerList={playerList} />
                                </div>
                            ))
                            :
                            <h3>No contributions yet...</h3>
                    }
                </div>
            </div>
        </div>
    )
}

export default ManageContributions